import React, { useState, useEffect } from 'react';
import { Navbar } from './header';
import { Footer } from './footer';
import { Newsletter } from './Newsletter';
import './Testimonials.css';

export const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      content: `Dearest Stories by Kalakaar Team,\n\nChoosing you for our wedding felt like casting the perfect lead for a blockbuster love story — someone who understands the script without even reading it. And oh, how beautifully you brought every chapter to life! You didn't just capture moments, you sculpted memories — from the emotional whispers during the vows to the chaotic fun of the baraat.\n\nEvery photograph feels like it breathes — alive with laughter, love, and everything in between. The 'filmy' ones, the stolen glances, and even our awkward candid moments — you turned them into timeless treasures.\n\nThank you for becoming a part of our story and giving us something we'll cherish forever. Our future anniversaries already have a visual soundtrack, thanks to you. Here's to many more magical memories — for us and for every lucky couple that walks into your lens.\n\nWith gratitude and lots of love,\nAarushi & Raghav Mehta`
    },
    {
      id: 2,
      content: `Big shoutout to Shresth & the whole Stories by Kalakaar crew!\nI had this super specific vision of a vibrant, colorful shoot that felt like a mix of royalty and roadside charm — and these guys nailed it without me even needing to make a Pinterest board.\n\nFrom finding the quirkiest corners of the city to styling our looks like pros, they made the whole process so effortless and fun. And just when I thought we'd run out of poses, they'd bring out new ideas that were totally non-cliché and super refreshing.\n\nOur families are OBSESSED with the final video — like, actually watching it on loop level obsessed. Can't get over how cinematic and yet so personal everything feels.\n\nDefinitely booking them again for any big event in the family. And trust me, after this, they're our go-to squad.`
    },
    {
      id: 3,
      content: `Guys I legit have no words 😭😭😭\nYou've turned the most special day of my life into something out of a dream — like HOW???? The wedding film had us all sobbing and laughing and gasping within 5 mins. Even my dad was emotional and he NEVER cries 🥹\n\nI swear I've watched my entry and vows scene like 10 times and still get goosebumps every single time. You captured every glance, every unsaid feeling, every vibe. I'm gonna be rewatching this every anniversary until forever 😭❤️\n\nTHANK YOU THANK YOU THANK YOU — for being absolute magicians behind the lens. You didn't just film our wedding… you made us FEEL it all over again.\nI'm crying again.\nToodles and endless love ✌🏼💖`
    },
    {
      id: 4,
      content: `No words, Shresth beta…\nBas itna kehna hai — dil se kaam karne wale log bahut kam hote hain… aur tum unmein se ek ho.\n\nJab pehli baar video dekha, aankhon mein aansu aa gaye. Har shot mein ek ehsaas tha… ek kahaani thi. Tabhi toh meri beti bina soche sab kuch tum logon ko handover karne ke liye tayyar thi.\n\nBahut izzat hai tumhare liye mere dil mein.\nTumne yaadon ko zinda kar diya… bas aise hi dil se kaam karte raho.\n\nGOD BLESS YOU, beta.\nMilte hain aaram se. Bahut baatein baaki hain abhi.`
    }
  ];

  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-in-section');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementBottom = element.getBoundingClientRect().bottom;
        const isVisible = (elementTop < window.innerHeight - 100) && (elementBottom > 0);
        if (isVisible) {
          element.classList.add('is-visible');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 9000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleDotClick = (index) => {
    setActiveTestimonial(index);
  };

  return (
    <div className="min-h-screen luxury-background">
      <Navbar />

      {/* Hero Section */}
      <div className="testimonials-hero fade-in-section">
        <h1 className="hero-title">Client Stories</h1>
        <div className="hero-line"></div>
        <p className="hero-subtitle">Cherished Memories & Heartfelt Words</p>
      </div>

      {/* Featured Testimonial Section */}
      <section className="featured-testimonial-section fade-in-section">
        <div className="featured-testimonial no-image">
          <blockquote className="testimonial-quote big-quote">
            {testimonials[activeTestimonial].content.split('\n').map((line, idx) => (
              <span key={idx}>
                {line}
                <br />
              </span>
            ))}
          </blockquote>
        </div>
        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === activeTestimonial ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
              aria-label={`View testimonial ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Grid Testimonials Section */}
      <section className="testimonials-grid fade-in-section">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="grid-testimonial no-image">
            <blockquote className="grid-quote">
              {testimonial.content.split('\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </blockquote>
          </div>
        ))}
      </section>

      {/* Call to Action Section */}
      <section className="testimonial-cta fade-in-section">
        <h2 className="cta-title">Your Story Awaits</h2>
        <p className="cta-text">
          Join our collection of cherished memories and let us tell your unique story through our lens.
        </p>
        <a href="/contactUs" className="cta-button">
          Begin Your Journey
        </a>
      </section>

      {/* Newsletter Section */}
      <Newsletter />
      
      <Footer />
    </div>
  );
};
